import { customElement } from 'lit/decorators.js';
import { connect } from 'pwa-helpers/connect-mixin.js';
import { TefComsCustomerAttributeInlineBase } from '@common/customerAttributes/TefComsCustomerAttributeInlineBase.js';
import { TemplatingMixin } from '@common/lit/mixins/TemplatingMixin.js';
import { Theme } from '@common/types/enum.js';
import { ReplaceElementsMixin } from '@src/components/mixins/ReplaceElementsMixin.js';
import { templates } from '@src/components/templates/index.js';
import { service } from '@src/service/index.js';
import {
  cancelPage, save, setCustomerAttribute,
} from '@src/store/consents.js';
import { store } from '@src/store/index.js';

const CompositeClass = ReplaceElementsMixin(
  TemplatingMixin(connect(store)(TefComsCustomerAttributeInlineBase), Theme.OCCL, templates),
);

@customElement('tef-coms-customer-attribute-inline')
export class TefComsCustomerAttributeInline extends CompositeClass {
  connectedCallback() {
    super.connectedCallback();
    // Only available here after store init and not on top of the class :(
    this.setTemplatingTheme(this.theme);

    if (!this.customerAttribute) {
      service.fireEvent('consents/ERROR', {
        level: 'error',
        message: `there is no customer attribute with id '${this.id}'`,
      });
      return;
    }

    // No editable customer attribute items?
    if (!this.hasAnyEditableCustomerAttributeItems) {
      service.fireEvent('consents/EMPTY', {
        level: 'info',
        message: 'there are no editable customer attribute items to be rendered',
      });
    }
  }

  save(): void {
    if (this.customerAttributeItemsStatusChanged) {
      store.dispatch(setCustomerAttribute(this.updatedCustomerAttribute));
      store.dispatch(save());
    }
  }

  cancel() {
    store.dispatch(cancelPage());
  }

  firstUpdated() {
    this.replaceElements();
  }

  get customerAttributes() {
    const { consents: { customerAttributes } } = store.getState();
    return customerAttributes!;
  }

  get theme() {
    const { config: { occluri } } = store.getState();
    return occluri ? Theme.OCCL : Theme.TEFONE;
  }

  getTemplateFnFor(templateName: string) {
    return this.getTemplateFn(templateName);
  }
}
